/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsField,
  AnalyticsField$inboundSchema,
} from "./analyticsfield.js";

export const AnalyticsDatasetKind = {
  Event: "event",
  Metric: "metric",
} as const;
export type AnalyticsDatasetKind = OpenEnum<typeof AnalyticsDatasetKind>;

/**
 * A dataset and the fields it exposes. The builder is generated from this.
 */
export type AnalyticsDataset = {
  description: string;
  fields: Array<AnalyticsField>;
  /**
   * What one row represents, as a noun
   */
  grain: string;
  kind: AnalyticsDatasetKind;
  name: string;
};

/** @internal */
export const AnalyticsDatasetKind$inboundSchema: z.ZodMiniType<
  AnalyticsDatasetKind,
  unknown
> = openEnums.inboundSchema(AnalyticsDatasetKind);

/** @internal */
export const AnalyticsDataset$inboundSchema: z.ZodMiniType<
  AnalyticsDataset,
  unknown
> = z.object({
  description: z.string(),
  fields: z.array(AnalyticsField$inboundSchema),
  grain: z.string(),
  kind: AnalyticsDatasetKind$inboundSchema,
  name: z.string(),
});

export function analyticsDatasetFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsDataset, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsDataset$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsDataset' from JSON`,
  );
}
